import React from 'react'
import NumberFilterItem from '@/components/pages/NewDatasetJobPage/NumberFilterItem'
import {CircularProgress, List} from '@mui/material'
import NewJobApiError from '@/components/pages/NewDatasetJobPage/NewJobApiError'
import {StyledCenteredDiv} from '@/components/pages/NewDatasetJobPage/StyledCenteredDiv'
import {NumberFilterValue, NumFilterOptions} from '@/components/pages/NewDatasetJobPage/types'

type NewJobNumberFilters = {
    numberFilters?: NumFilterOptions[]
    selectedFilters: Record<string, NumberFilterValue>
    onFilterSelect: (filterName: string, checked: boolean, filterVal: any) => void
    isLoading: boolean
    error?: boolean
}

const NewJobNumberFilters = ({
    numberFilters,
    selectedFilters,
    onFilterSelect,
    isLoading,
    error
}: NewJobNumberFilters) => {

    if (isLoading) {
        return <StyledCenteredDiv><CircularProgress/></StyledCenteredDiv>
    }

    if (error) {
        return <NewJobApiError text="Unable to load filters"/>
    }

    if (numberFilters === undefined) {
        return <div>Select Database to load num filters</div>
    }

    if(numberFilters.length === 0) {
        return <div>No num filters available</div>
    }

    return <List>
        {numberFilters?.map((numFilter: NumFilterOptions, idx: number) => (
            <NumberFilterItem key={'num-filter-' + idx}
                numberFilterOpts={numFilter}
                checked={!!selectedFilters[numFilter.name]}
                onFilterChange={onFilterSelect}
                inputMin={selectedFilters[numFilter.name]?.min}
                inputMax={selectedFilters[numFilter.name]?.max}
            />
        ))}
    </List>
}

export default NewJobNumberFilters